import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import PageLayout from "components/layout/page-layout";
import ActionButton from "components/table/action-btn";
import Table, { tableHeader } from "components/table";
import { oneLine } from "components/table/table-parts";
import { IconEye, IconLock, IconLockOpen, IconPencil } from "@tabler/icons-react";
import { useSharedState } from "state";
import WarningModal from "components/modal/warning";
import { updateContractor } from "api/contractor";
import { ContractorDefault, ContractorType } from "types/dict";

export default function Contractors() {
  const { contractors, getContractorsData, notify } = useSharedState();

  const navigate = useNavigate();

  const [contractorToBlock, setContractorToBlock] = useState<ContractorType>(ContractorDefault);
  const [isFormLoading, setFormLoading] = useState<boolean>(false);

  const blockDanger = "Вы действительно хотите изменить статус контрагента?";

  useEffect(() => {
    getContractorsData();
  }, []);

  const onContractorBlock = async () => {
    setFormLoading(true);

    try {
      await updateContractor(
        contractorToBlock.contragent_id,
        contractorToBlock.contragent,
        true,
        contractorToBlock.bin,
        !contractorToBlock.status
      );
      notify("Статус изменён", "success");

      await getContractorsData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при изменении статуса");
    } finally {
      setFormLoading(false);
      setContractorToBlock(ContractorDefault);
    }
  };

  const contractorsTableHeaders: tableHeader[] = [
    { header_text: "Название контрагента", narrow: false, wrap: false },
    { header_text: "БИН", narrow: false, wrap: false },
    { header_text: "Статус", narrow: false, wrap: false },
    { header_text: "Действия", narrow: false, wrap: false },
  ];

  const contractorsList = (
    <>
      {contractors.map((contractor, index) => (
        <tr key={index}>
          <td>{oneLine(contractor.contragent)}</td>
          <td>{oneLine(contractor.bin)}</td>
          <td>{oneLine(contractor.status ? "Активный" : "Неактивный", contractor.status ? "primary" : "danger")}</td>
          <td>
            <div className="btn-list flex-nowrap">
              <ActionButton
                icon={<IconEye className="icon" />}
                title="Детали"
                action={() => navigate(`${contractor.contragent_id}/detail`)}
                disabled={isFormLoading}
                color={"primary"}
                modal={false}
              />
              <ActionButton
                icon={<IconPencil className="icon" />}
                title="Изменить"
                action={() => navigate(`${contractor.contragent_id}`)}
                disabled={isFormLoading}
                color={"primary"}
                modal={false}
              />
              <ActionButton
                icon={contractor.status ? <IconLock className="icon" /> : <IconLockOpen className="icon" />}
                title={`${contractor.status ? "Деактивировать" : "Активировать"}`}
                action={() => setContractorToBlock(contractor)}
                disabled={isFormLoading}
                color={`${contractor.status ? "danger" : "primary"}`}
                modal={true}
                modal_id="#modal-block-contractor"
              />
            </div>
          </td>
        </tr>
      ))}
    </>
  );

  const contractorsTable = Table(contractorsTableHeaders, contractorsList, false);

  return (
    <>
      <PageLayout
        children={contractorsTable}
        header={"Контрагенты"}
        subheaderText={`Количество контрагентов: ${contractors.length}`}
        search={false}
        filters={false}
        sorters={false}
        buttonText={"Новый контрагент"}
        buttonAction={() => navigate("create")}
      />
      <WarningModal
        modal_id="modal-block-contractor"
        warningDescription={blockDanger}
        cancel={() => setContractorToBlock(ContractorDefault)}
        confirm={onContractorBlock}
      />
      <Outlet />
    </>
  );
}
